import React from 'react';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import { ChevronLeftIconSVG } from 's2s-svg-icons';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';

const SettingsContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  min-width: 320px;
`;

const HeaderStyle = styled.div`
  align-items: center;
  background: #182661;
  color: ${colorGrid.gray0};
  display: flex;
  font-size: 16px;
  min-height: 48px;
  justify-content: space-between;
`;

const HeaderText = styled.span`
  font-family: Poppins;
  font-size: 20px;
  font-weight: 600;
`;

const CenteringDiv = styled.div`
  background-color: transparent;
  border: none;
  border-radius: 0px;
  height: 48px;
  margin-right: 0px;
  padding: 0px;
  width: 48px;
`;

const BackContainer = styled(CenteringDiv)`
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-left: 8px;
  width: 32px;

  :hover {
    background-color: #0C1331;
  }
`;

const SettingsNav = (props) => {
  // Add intl to children props
  const children = React.Children.map(props.children, (child) => {
    return React.cloneElement(child, {
      intl: props.intl
    });
  });

  return (
    <SettingsContainer>
      <HeaderStyle className="settingsHeader">
        <BackContainer onClick={props.cbBackClick}>
          <ChevronLeftIconSVG svgStyle={{
            fill: '#F8F9FA',
            height: '24px',
            padding: '0px',
            width: '24px'
          }} />
        </BackContainer>
        <HeaderText>
          {props.title ? props.title : getIntlText(props.intl, 'HEADER-SETTINGS-TITLE', "Settings")}
        </HeaderText>
        {/* The following div is in place so that the title can be centered properly within the header */}
        <CenteringDiv />
      </HeaderStyle>
      {children}
    </SettingsContainer>
  );
};

SettingsNav.propTypes = {
  cbBackClick: PropTypes.func,
  cbSettingsCategoryClick: PropTypes.func,
  intl: PropTypes.object,
  title: PropTypes.string
};

SettingsNav.defaultProps = {
  cbBackClick: () => { console.log("Please define a callback function for cbBackClick in the settings component"); },
  cbSettingsCategoryClick: () => { console.log("Please define a callback function for cbSettingsCategoryClick in the settings component"); },
  title: undefined, //title defaults to undefined because we can not default it to an internationalized value (due to lacking props.intl)
};

export default injectIntl(SettingsNav);
